import { motion } from "framer-motion";
import { User, Zap, Users, Cpu, ArrowRight } from "lucide-react";

const SERVICES = [
  {
    icon: User, testid: "service-card-individuale", span: "md:col-span-7",
    title: "Percorsi Individuali",
    desc: "Sessioni one-to-one costruite sull'atleta: obiettivi, paure, punti di forza. Ogni percorso è un piano di configurazione mentale personalizzato, con esercizi concreti da portare in campo e nella vita.",
    tags: ["One-to-one", "Online o in presenza", "Piano personalizzato"],
  },
  {
    icon: Zap, testid: "service-card-gara", span: "md:col-span-5",
    title: "Preparazione Mentale Gara",
    desc: "Routine pre-gara, gestione del pre-partita, reset post-errore. Arriva al fischio d'inizio con i parametri giusti.",
    tags: ["Routine pre-gara", "Focus"],
  },
  {
    icon: Users, testid: "service-card-societa", span: "md:col-span-5",
    title: "Società & Settori Giovanili",
    desc: "Programmi per società sportive: formazione allenatori, workshop per atleti e incontri dedicati ai genitori. Una cultura mentale condivisa fa crescere tutto il vivaio.",
    tags: ["Workshop", "Staff tecnico", "Genitori"],
  },
  {
    icon: Cpu, testid: "service-card-ai-protocol", span: "md:col-span-7",
    title: "Rendiamo gli atleti emotivamente intelligenti",
    desc: "Il mio metodo distintivo: trattiamo lo stato emotivo come un sistema configurabile. Focus, ansia, fiducia e grinta diventano parametri da misurare, allenare e ottimizzare — con strumenti di auto-monitoraggio che l'atleta impara a usare in autonomia.",
    tags: ["Metodo esclusivo", "Auto-monitoraggio", "Misurabile"],
  },
];

export const Servizi = () => (
  <section id="servizi" data-testid="servizi-section" className="py-16 sm:py-24 lg:py-32 bg-[#0A0D13]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
        className="max-w-2xl">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-orange-400">Servizi</span>
        <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
          Programmi di configurazione mentale per ogni esigenza
        </h2>
      </motion.div>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
        {SERVICES.map((s, i) => (
          <motion.div key={s.title} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}
            data-testid={s.testid}
            className={`${s.span} relative bg-[#10141D] border border-[#222A3B] hover:border-[#00E5FF]/50 transition-all duration-300 rounded-2xl overflow-hidden shadow-lg hover:shadow-[0_0_30px_rgba(56,189,248,0.15)] p-6 sm:p-8 group`}>
            <div className="w-12 h-12 rounded-xl bg-sky-500/10 border border-sky-500/30 flex items-center justify-center mb-5 group-hover:bg-sky-500/20 transition-colors">
              <s.icon className="w-6 h-6 text-sky-400" />
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold text-white font-heading">{s.title}</h3>
            <p className="mt-3 text-sm sm:text-base text-slate-300 leading-relaxed">{s.desc}</p>
            <div className="mt-5 flex flex-wrap gap-2">
              {s.tags.map((t) => (
                <span key={t} className="px-3 py-1 rounded-full text-xs font-medium bg-white/5 border border-white/10 text-slate-300">{t}</span>
              ))}
            </div>
            <a href="#prenota" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-sky-400 hover:text-sky-300 transition-colors">
              Prenota ora <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
